export const additionalForwardableProps = new Set([
    'form',
    'formAction',
    'formEncType',
    'formMethod',
    'formNoValidate',
    'formTarget',
    'name',
    'value',
    // react-router Link props
    'reloadDocument',
    'replace',
    'state',
    'preventScrollReset',
    'relative',
    'to',
]);
//# sourceMappingURL=additionalForwardableProps.js.map